import gql from 'graphql-tag';

export const getCartMetaDataQuery = (
  subscriptionFeatureActive: boolean | null = null,
) => gql`
  query getCartMetaData($organizationProfileId: Int, $defaultProducts: [Int]) {
    getCartMetaData(
      organizationProfileId: $organizationProfileId
      defaultProducts: $defaultProducts
    ) {
      credits {
        label
        amount
        organizationName
        fromParentOrg
        balances {
          frontend
          transactionBalances {
            creditType
            amount
          }
        }
      }
      defaultProduct {
        id
        name
        priceNumber
        priceCurrency
        excludeJobFlatrateSubscription
        frontends
      }
      store {
        id
        name
        mail
        currency
        address {
          countryCode
          administrativeArea
          locality
          addressLine1
          addressLine2
          zip
        }
      }
      defaultProductUserCredits {
        amount
        type
        balances {
          frontend
          transactionBalances {
            creditType
            amount
          }
        }
      }
      ${
        subscriptionFeatureActive
          ? `
          flatrateSubscription {
            type
            label
            availableJobSlots
          }
          activeJobFlatrateSubscriptions {
            id
            label
            frontend
          }`
          : ''
      }
    }
  }
`;
